import {useContext} from 'react'
import {AccountStyleContext} from '@containers/accountStyle/context/AccountStyleProvider'
import {buildAccountStyleTokens} from '@containers/accountStyle/helpers/buildAccountStyleTokens'
import {DEFAULT_ACCOUNT_MENU_COLOR} from '@containers/accountStyle/constants/palette'
import {IAccountStyleContext} from '@containers/accountStyle/types'

const FALLBACK: IAccountStyleContext = {
	menuColor: DEFAULT_ACCOUNT_MENU_COLOR,
	userMenuColor: null,
	tokens: buildAccountStyleTokens(DEFAULT_ACCOUNT_MENU_COLOR, 'light'),
}

export const useAccountStyle = (): IAccountStyleContext => {
	return useContext(AccountStyleContext) ?? FALLBACK
}
